import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.vrName = ''
      this.top = ''
    }
  }
}
export default searchFrom
